import * as R from 'ramda'
import {
  ADD_SUBSTITUTE,
  ADD_NEW_SUBSTITUTE,
  CLEAR_NEW_SUBSTITUTE,
  REMOVE_SUBSTITUTES,
  RESET_SUBSTITUTES,
  UPDATE_SUBSTITUTES,
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'

const removeSubstitutes = (prevSubstitutes, { username }) => R.omit([username], prevSubstitutes)

const updateSubstitutes = (prevSubstitutes, { substitutes }) => {
  const newSubstitutes = substitutes ? substitutes : {}
  return R.merge(prevSubstitutes, newSubstitutes)
}

const addSubstitute = (prevSubstitutes, { substitute }) => {
  const newSubstitute = substitute
    ? { [substitute.username]: { ...substitute, startDate: new Date(), endDate: new Date() } }
    : {}
  return R.merge(prevSubstitutes, newSubstitute)
}

const addNewSubstitute = (prevSubstitute, { substitute }) => {
  return substitute ? substitute : prevSubstitute
}

const addNewSubstituteReducer = createReducer({}, {
  [CLEAR_NEW_SUBSTITUTE]: () => ({}),
  [ADD_NEW_SUBSTITUTE]: addNewSubstitute,
})

const substitutesReducer = createReducer([], {
  [RESET_SUBSTITUTES]: () => [],
  [ADD_SUBSTITUTE]: addSubstitute,
  [UPDATE_SUBSTITUTES]: updateSubstitutes,
  [REMOVE_SUBSTITUTES]: removeSubstitutes
})

export {
  substitutesReducer,
  addNewSubstituteReducer,
}
